import axios from 'axios';
import { MessageBox, Loading } from 'element-ui';

let loadingCount = 0;
let loading;

const startLoading = () => { 
	loading = Loading.service({  
		lock: true,
		  text: '加载中……',
		  background: 'rgba(0, 0, 0, 0.7)' 
	});
};

const endLoading = () => { 
	loading.close();
};

const showLoading = () => { 
	if(loadingCount === 0) {  
		startLoading(); 
	} 
	loadingCount += 1;
};

const hideLoading = () => { 
	if(loadingCount <= 0) {  
		return; 
	} 
	loadingCount -= 1; 
	if(loadingCount === 0) {  
		endLoading(); 
	}
};

const admin = {
	state: {
		catesBarList: [

			/*{
				title: '机构管理',
				icon: require('../../imgs/jggl.png'),
				path: '/jgAdmin'
			},*/
			{
				title: '服务管理',
				icon: require('../../imgs/fwgl.png'),
				path: '/serviceAdmin'
			},
			{
				title: '员工管理',
				icon: require('../../imgs/yggl.png'),
				path: '/ygAdmin'
			},
			{
				title: '部门管理',
				icon: require('../../imgs/dept.png'),
				path: '/deptAdmin'
			},
			/*{
				title: '用户管理',
				icon: require('../../imgs/yhgl.png'),
				path: '/userAdmin'
			},*/
			
			/*{
				title: '收费管理',
				icon: require('../../imgs/sfgl.png'),
				path: '/sfAdmin'
			},*/
			{
				title: '资讯管理',
				icon: require('../../imgs/zxgl.png'),
				path: '/newsAdmin'
			},
			/*{
				title: '设备管理',
				icon: require('../../imgs/sbgl.png'),
				path: '/shebeiAdmin'
			},*/
			/*{
				title: '考核管理',
				icon: require('../../imgs/khgl.png'),
				path: '/testAdmin'
			},*/
			{
				title: '数据看板',
				icon: require('../../imgs/sjkb.png'),
				path: '/blockBook'
			},
			
			{
				title: 'APP更新',
				icon: require('../../imgs/yggl.png'),
				path: '/updateApp'
			},
			// {
			// 	title: '12345热线',
			// 	icon: require('../../imgs/12345.png'),
			// 	path: '/hotLine'
			// },
			{
				title: '报表统计',
				icon: require('../../imgs/pay-icon.png'),
				path: '/payForm'
			},
			{
				title: '客户端资讯',
				icon: require('../../imgs/zxgl.png'),
				path: '/newsClient'
			},
			/*{
				title: '权限管理',
				icon: require('../../imgs/qxgl.png'),
				path: '/qxAdmin'
			},
			{
				title: '角色管理',
				icon: require('../../imgs/jsgl.png'),
				path: '/jsAdmin'
			},*/
		],
		worksList: {
			data: [],
			pageVo: ''
		},
		currentPointer: '',
		// 今日新增
		chartTodayList: [],
		// 今日处理
		chartFinished: [],
		// 今日处理中
		chartDoing: [],
		// 今日工单总数
		chartCount: [],
		worksDetail: [],
		// 办理中工单列表
		worksComList: [],
		//已完结工单-关键字-坐席
		worksFinishList: []
	},
	actions: {
		// 待处理工单
		getWroksList({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/zx/selectListWaitAllot' + param, {
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					})
					.then(res => {
		
						console.log(res.data);
						if(res.data.status != '1') {

							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('GETWORKSLIST', res.data)
							resolve(res.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
		// 办理中工单
		getCompleteList({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/zx/selectListUnComplete' + param, {
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					})
					.then(res => {

						if(res.data.status != '1') {
							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('GETCOMPLETELIST', res.data)
							resolve(res.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
		// 查-已完结工单-关键字-坐席
		getFinishedList({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/zx/selectListFinished' + param, {
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						},
						async: false, // fasle表示同步请求，true表示异步请求
					})
					.then(res => {
						if(res.data.status != '1') {

							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('GETFINISHEDLIST', res.data)
							resolve(res.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
		// 服务管理 今日新增
		chartToday({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/statistics/selectCountDayByAdd',
						// {headers:{'Content-Type':'application/json'}}
						{
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}
					)
					.then(res => {
						if(res.data.status != '1') {

							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('CHARTTODAY', res.data)
							resolve(res.data.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
		// 服务管理 - 今日处理
		chartTodayFinished({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/statistics/selectCountDayByDone',
						// {headers:{'Content-Type':'application/json'}}
						{
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}
					)
					.then(res => {
						if(res.data.status != '1') {

							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('CHARTTODAYFINISHED', res.data)
							resolve(res.data.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
		// 服务管理 - 处理中
		chartTodayDoing({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/statistics/selectCountDayByDoing',
						// {headers:{'Content-Type':'application/json'}}
						{
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}
					)
					.then(res => {
						if(res.data.status != '1') {

							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('CHARTTODAYDOING', res.data)
							resolve(res.data.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
		// 服务管理 - 工单总数
		chartTodayCountSum({
			commit
		}, param) {
			return new Promise((resolve, reject) => {
				showLoading();
				axios.post('/api/work_order/statistics/selectCountDayBySum',
						// {headers:{'Content-Type':'application/json'}}
						{
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}
					)
					.then(res => {
						if(res.data.status != '1') {

							hideLoading();
							return false;
						}
						if(res.data.data) {
							commit('CHARTTODAYCOUNTSUM', res.data)
							resolve(res.data.data)
							hideLoading();
						}
					}).catch(err => {
						reject(err)
						hideLoading();
					})
			})
		},
	},
	getters: {

	},
	mutations: {
		CHARTTODAY(state, info) {
			if(info.status == '1') {
				state.chartTodayList = info.data;
			}
		},
		CHARTTODAYFINISHED(state, info) {
			if(info.status == '1') {
				state.chartFinished = info.data;
			}
		},
		CHARTTODAYCOUNTSUM(state, info) {
			if(info.status == '1') {
				state.chartCount = info.data;
			}
		},
		CHARTTODAYDOING(state, info) {
			if(info.status == '1') {
				state.chartDoing = info.data;
			}
		},
		GETWORKSLIST(state, info) {
			showLoading()
			
			info.data.forEach((value, index) => {
				let {
					p_dept_id,
					p_com_id
				} = value;
				// 根据id查部门
				let dept = new Promise(resolve => {
					axios.post('/api/dept/selectById?id=' + p_dept_id)
						.then(res => {
							if(res.data.status != '1') {
								hideLoading();
								return false;
							}
							let data = res.data.data;
							resolve(data.dept_name);
						})
				}).catch(err => {
					console.log(err)
				})
				dept.then(name => {
					hideLoading();
					value.dept_name = name
					state.worksList.data.push(value);
					state.worksDetail.push(value)
				}).catch(err => {
					console.log(err)
				})

			})
			//state.worksList.data = info.data;
			state.worksList.pageVo = info.pageVo;
			state.currentPointer = info.pageVo;
			console.log(state.currentPointer)
		},
		GETCOMPLETELIST(state, info) {
			state.worksComList.data = info.data;
		},
		GETFINISHEDLIST(state, info) {
			state.worksFinishList.data = info.data;
		},
	}
}
export default admin


// WEBPACK FOOTER //
// ./src/store/modules/admin.js